import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { DeleteOfferResponse } from "./deleteSpecialOffer.types";

export const requestDeleteOffer = async (
  offerId: string
): Promise<DeleteOfferResponse> => {
  return await instance.delete(
    buildUrl(ApiRoutesOffers.SpecialOffers, offerId)
  );
};
